import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
export const SKIP_API_KEY = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_TOASTS = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_AUTH_REDIRECTS = new HttpContextToken<boolean>(() => false);
